import apiClient from './apiClient';

export interface QueryParams {
  report_type?: string;      // "company", "codemap", or "both"
  company_from?: string;
  company_to?: string;
  category_type?: string;    // "all", "C", "CD", "F", "M"
}

export interface AddressRow {
  F1041_11: string;  // label
  F1041_12: string;  // address
  F1041_13: string;  // tel
  F1041_14: string;  // fax
}

export interface ContactRow {
  F1042_11: string;  // dept
  F1042_02: string;  // name
  F1042_14: string;  // ext
  F1042_13: string;  // tel
  F1042_12: string;  // cell
  F1042_15: string;  // email
}

export interface CompanyRow {
  F104_01: string;      // company code
  F104_02: string;      // category
  F104_11: string;      // short name
  F104_12: string;      // cn name
  F104_13: string;      // en name
  F104_14: string;      // currency
  F104_17: string;      // tax id
  F104_21: string;      // phone
  addresses: AddressRow[];
  contacts: ContactRow[];
}

export interface CodeMapRow {
  F104_01: string;
  F104_02: string;
  F104_11: string;
  F104_12: string;
  F104_13: string;
}

export interface GroupCount {
  code: string;
  count: number;
}

export interface QueryResponse {
  companies: CompanyRow[] | null;
  code_map: CodeMapRow[] | null;
  count: number;
  groups: GroupCount[] | null;
  message?: string;
}

export const p1304Api = {
  async query(params: QueryParams): Promise<QueryResponse> {
    const res = await apiClient.post('/api/p1304/query', params);
    return res.data;
  },
  async lookupName(code: string): Promise<string> {
    if (!code?.trim()) return '';
    try {
      const res = await apiClient.get(`/api/p1304/lookup/company/${encodeURIComponent(code.trim())}`);
      return res.data.name || '';
    } catch { return ''; }
  },
};
